<template>
	<div class="meter-water-manage-container">
		<el-card shadow="never" class="search-card">
			<div slot="header" class="card-header">
				<span>查询条件</span>
			</div>
			<div class="flex justify-start">
				<el-form :inline="true" :model="queryParams">
					<el-form-item>
						<el-input v-model="queryParams.carNo" placeholder="必填，请填写车牌号" clearable style="width: 800px" />
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="handleSearch">查询</el-button>
						<el-button @click="handleReset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>

		</el-card>

		<el-card shadow="never" class="table-card">
			<div slot="header" class="card-header">
				<span>月租车</span>
				<div>
					<el-button size="small" @click="handleAdd">添加</el-button>
				</div>
			</div>
			<el-table :data="list" v-loading="loading" border stripe>
				<el-table-column type="index" label="序号" width="50" />
				<el-table-column prop="userNo" label="人员编号" width="120" align="center">
					<template slot-scope="{ row }">
						<span v-if="row.userNo" style="color: #409EFF;"><i class="el-icon-collection"
								style="margin-right: 3px;font-size: 16px;"></i>{{row.userNo}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="carNo" label="车牌号" width="120" align="center" />
				<el-table-column label="车辆类型编码" width="120" align="center">
					<template slot-scope="{ row }">{{ row.carTypeNo || '日钢' }}</template>
				</el-table-column>
				<el-table-column prop="iusseTime" label="发行时间" width="200" align="center" />
				<el-table-column prop="beginTime" label="有效期起" width="200" align="center" />
				<el-table-column prop="endTime" label="有效期止" width="200" align="center" />
				<!-- <el-table-column label="剩余天数" width="100" align="center">
					<template slot-scope="{ row }">{{ row.stateName || '正常' }}</template>
				</el-table-column> -->
				<el-table-column prop="userName" label="车主姓名" width="150" align="center">
					<template slot-scope="{ row }">
						<span style="color: #409EFF;" v-if="row.userName"><i class="el-icon-user"
								style="margin-right: 3px;font-size: 16px;"></i>{{row.userName}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="phone" label="手机号码" width="150" align="center">
					<template slot-scope="{ row }">
						<span style="color: #409EFF;" v-if="row.phone"><i class="el-icon-phone"
								style="margin-right: 3px;font-size: 16px;"></i>{{row.phone}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="homeAddress" label="住址" align="center" />
				<!-- <el-table-column prop="createTime" label="创建时间" min-width="160" align="center" /> -->
				<el-table-column label="操作" width="100" fixed="right" align="center">
					<template slot-scope="{ row }">
						<el-button size="small" type="text" @click="handleEdit(row)">修改</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination :current-page="queryParams.indexId+1" :page-size="queryParams.size" :total="total"
				:page-sizes="[10, 20, 50]" layout="total, sizes, prev, pager, next, jumper"
				@size-change="handleSizeChange" @current-change="handlePageChange" class="pagination-container" />
		</el-card>
		<EditOwnerCar :visible.sync="ownerCarVisible" :charge-data="currentRow" @success="handleSuccess" />
	</div>
</template>

<script>
	import {
		randomDecimal,
		generateSign
	} from '@/api/common/parkAreaApi'
	import EditOwnerCar from '@/components/park/EditOwnerCar.vue'
	import axios from 'axios'

	export default {
		name: 'ParkingOwnerCar',
		components: {
			EditOwnerCar
		},
		data() {
			return {
				loading: false,
				list: [],
				total: 0,
				queryParams: {
					indexId: 0,
					size: 20,
					carNo: "",
					appid: "ym6c157cca12185f0d",
					rand: "",
					version: "v1.1",
					parkKey: "eegy2vge"
				},
				currentRow: null,
				ownerCarVisible: false
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			async loadData() {
				this.loading = true
				try {
					const rand = await randomDecimal()
					this.queryParams.rand = rand.toString()
					this.$delete(this.queryParams, 'sign')
					this.queryParams.sign = await generateSign(this.queryParams)
					const {
						data
					} = await axios.post('/Api/Inquire/GetMthCarInfo', this.queryParams)
					const res = data
					this.list = Array.isArray(res.data) ? res.data : (res.data ? [res.data] : [])
					if (this.queryParams.indexId === 0) {
						this.total = this.list.length
						if (this.list.length >= 20) {
							this.getAllTotal(1)
						}
					}
				} catch (e) {
					console.error('获取月租车失败', e)
				} finally {
					this.loading = false
				}
			},
			async getAllTotal(index) {
				try {
					const dataParams = JSON.parse(JSON.stringify(this.queryParams))
					dataParams.indexId = index
					const rand = await randomDecimal()
					dataParams.rand = rand.toString()
					this.$delete(dataParams, 'sign')
					dataParams.sign = await generateSign(dataParams)
					const {
						data
					} = await axios.post('/Api/Inquire/GetMthCarInfo', dataParams)
					const res = data
					if (res.code === 1) {
						this.total += res.data.length;
					}
					if (res.code === 1 && res.data.length >= 20) {
						await new Promise(resolve => setTimeout(resolve, 500));
						await this.getAllTotal(index + 1)
					}
				} catch (e) {
					console.error('获取月租车记录失败', e)
				}
			},
			handleSearch() {
				this.queryParams.indexId = 0;
				this.loadData()
			},
			handleReset() {
				this.queryParams = {
					indexId: 0,
					size: 20,
					carNo: "",
					appid: "ym6c157cca12185f0d",
					rand: "",
					version: "v1.1",
					parkKey: "eegy2vge"
				};
				this.loadData()
			},
			handleSizeChange(val) {
				this.queryParams.size = val;
				this.loadData()
			},
			handlePageChange(val) {
				this.queryParams.indexId = val - 1;
				this.loadData()
			},
			// 新增月租车
			handleAdd() {
				this.currentRow = null
				this.ownerCarVisible = true
			},
			handleEdit(row) {
				this.currentRow = { ...row }
				this.ownerCarVisible = true
			},
			handleSuccess() {
				this.loadData()
			},
		}
	}
</script>

<style lang="scss" scoped>
	.meter-water-manage-container {
		padding: 20px;

		.tree-container {
			min-height: 450px;
			overflow-y: auto;
			background: #fff;
			padding: 10px;
			border-radius: 4px;
		}

		.margin-top {
			margin-top: 20px;
		}

		.clearfix:before,
		.clearfix:after {
			display: table;
			content: '';
		}

		.clearfix:after {
			clear: both;
		}
	}

	.tab-component {
		padding: 0;
	}

	.search-card {
		margin-bottom: 16px;
	}

	.table-card {
		margin-bottom: 0;
	}

	.card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.pagination-container {
		text-align: right;
		margin-top: 16px;
	}
</style>